import { graphql } from "generated/gql";

export const getOrgSitesFromSubdomainDocument = graphql(/* GraphQL */ `
  query GetOrgCollectionSites($organisationSubdomain: String!) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      collectionSites {
        ...MeCollectionSitesFields
      }
    }
  }
`);

export const getOrgAndSiteFromNamesDocument = graphql(/* GraphQL */ `
  query GetCollectionSiteFromNames(
    $organisationSubdomain: String!
    $collectionSiteSlug: String!
  ) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      ...MeOrganisationFields
      site: collectionSiteBySlug(slug: $collectionSiteSlug) {
        ...MeCollectionSitesFields
      }
    }
  }
`);

export const getOrganisationFromNameDocument = graphql(/* GraphQL */ `
  query GetOrganisationFromName($organisationSubdomain: String!) {
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      ...MeOrganisationFields
    }
  }
`);
